module.exports = __webpack_public_path__ + "img/pic-maria-howard.143fa305.jpg";